import { isNavigationFailure } from 'vue-router'
import { setPageTitle } from '@/utils/pageTitle.js'
import routeLoading from '@/stores/routeLoadingStore.js'

// O download do chunk da rota acontece entre o beforeEach e o afterEach. É a janela em que a
// página antiga ainda está na tela e o overlay da página nova ainda não existe.
export function aoIniciarNavegacao() {
  routeLoading.start()
}

/**
 * Roda ao fim de toda navegação — inclusive nas que NÃO aconteceram.
 *
 * O `afterEach` do Vue Router é chamado também quando a navegação falha, com a falha no
 * terceiro argumento. Sem checar isso, o "Continuar Editando" do aviso de alterações não
 * salvas trocava o nome da aba: a guarda devolvia `false`, a tela continuava a mesma e a
 * aba passava a exibir o título da tela que não chegou a abrir.
 *
 * As três falhas do roteador querem o mesmo tratamento — não mexer no título:
 * `aborted` (guarda barrou, seguimos onde estávamos), `cancelled` (outra navegação
 * começou por cima e é ela quem vai definir o título) e `duplicated` (já estamos lá, o
 * título já está certo).
 *
 * O indicador de carregamento, ao contrário, precisa parar em qualquer desfecho.
 */
export function aoTerminarNavegacao(to, from, failure) {
  routeLoading.stop()

  if (isNavigationFailure(failure)) {
    return
  }

  // Telas que têm um título mais específico (o número do processo, o nome do colaborador)
  // sobrescrevem este valor pelo BreadCrumb, que é quem conhece o título de fato mostrado.
  setPageTitle(to.meta?.title)
}

export function aoFalharNavegacao() {
  routeLoading.stop()
}
